import { combineReducers } from "redux";

// reducers
import getHomePageWidget from "./reducer/getHomePageWidgetReducer";
import getAppointmentDetail from "./reducer/getAppointmentDetailReducer";
import getAppointmentSearch from "./reducer/getAppointmentSearchReducer";
import getPatientList from "./reducer/getPatientListReducer";
import updatePatientDetail from "./reducer/updatePatientDetailReducer";
import getAppointmentList from "./reducer/getAppointmentListReducer";
import getCouponList from "./reducer/getCouponListReducer";
import deleteCoupon from "./reducer/deleteCouponReducer";
import getCouponDetail from "./reducer/getCouponDetailReducer";
import saveCoupon from "./reducer/saveCouponReducer";
import deletePatientList from "./reducer/deletePatientListReducer";
import getPatientDetail from "./reducer/getPatientDetailReducer";
import getConsultationView from "./reducer/getConsultationViewReducer";
import saveScheduleTiming from "./reducer/saveScheduleTimingReducer";
import getScheduleTimingList from "./reducer/getScheduleTimingListReducer";
import getAllScheduleTimingList from "./reducer/getAllScheduleTimingListReducer";
import saveScheduleTimingCustomize from "./reducer/saveScheduleTimingCustomizeReducer";
import deleteScheduleTimeSlot from "./reducer/deleteScheduleTimeSlotReducer";
import saveAppointment from "./reducer/saveAppointmentReducer";
import getPatientDropdownList from "./reducer/getPatientDropdownListReducer";
import login from './reducer/loginReducer'
import getDoctorDetail from './reducer/getDoctorDetailReducer'
import getPatientAppointmentList from './reducer/getPatientAppointmentListReducer'
import savePatientIntakeForm from './reducer/savePatientIntakeFormReducer'
import getPageContentDetail from './reducer/getPageContentDetailReducer'
import getPatientDetailForIntakeForm from './reducer/getPatientDetailForIntakeFormReducer'
import saveAppointmentReport from './reducer/saveAppointmentReportReducer'
import updateDoctorDetail from './reducer/updateDoctorDetailReducer'
import resetPassword from './reducer/resetPasswordReducer'
import getListTestMaster from './reducer/getListTestMasterReducer'
import getInstituteList from './reducer/getInstituteListReducer'
import getContainerList from './reducer/getContainerListReducer'
import saveEmergencyDtrf from './reducer/saveEmergencyDtrfReducer'
import getEmergencyDtrfList from './reducer/getEmergencyDtrfListReducer'
import getCommonMasterList from './reducer/getCommonMasterListReducer'
import saveAppointmentCompleteStatus from './reducer/saveAppointmentCompleteStatusReducer'
import saveAppointmentNotAttendedStatus from './reducer/saveAppointmentNotAttendedStatusReducer'
import getArticleList from './reducer/getArticleListReducer'
import getArticleHomeList from './reducer/getArticleHomeListReducer'
import getArticleBySlug from './reducer/getArticleBySlugReducer'
import saveDoctor from './reducer/saveDoctorReducer'
import sendOtpForForgotPassword from './reducer/sendOtpForForgotPasswordReducer'
import resetForgotPassword from './reducer/resetForgotPasswordReducer'
import getDtrfReportList from './reducer/getDtrfReportListReducer'
import getTestBookList from './reducer/getTestBookListReducer'
import getBookmarkArticles from './reducer/getBookmarkArticleReducer'
import getTestimonial from './reducer/getTestimonialReducer'
import getQuickSupport from './reducer/getQuickSupportReducer'
import bookedAppointmentActivityState from "./reducer/bookedAppointmentAcitivityReducer"
import sendSignUpRequestState from "./reducer/sendSignUpRequestReducer"
import cancelAppointment from "./reducer/cancelAppointmentReducer";
import getTestCategories from "./reducer/getTestCategoriesReducer";
import getTokenDetails from "./reducer/getTokenDetailsReducer";
import saveArticleBookmark from "./reducer/saveArticleBookmarkReducer";
import saveArticleLike from './reducer/saveArticleLikeReducer'
import getArticleTags from "./reducer/getArticleTagsReducer";
export default combineReducers({
  getHomePageWidget,
  getAppointmentDetail,
  getAppointmentSearch,
  getPatientList,
  updatePatientDetail,
  getAppointmentList,
  getCouponList,
  deleteCoupon,
  getCouponDetail,
  saveCoupon,
  getPatientDropdownList,
  deletePatientList,
  getPatientDetail,
  saveScheduleTimingCustomize,
  saveScheduleTiming,
  getScheduleTimingList,
  getAllScheduleTimingList,
  deleteScheduleTimeSlot,
  saveAppointment,
  login,
  getDoctorDetail,
  getPatientAppointmentList,
  savePatientIntakeForm,
  getPageContentDetail,
  getPatientDetailForIntakeForm,
  saveAppointmentReport,
  updateDoctorDetail,
  resetPassword,
  getListTestMaster,
  getInstituteList,
  getContainerList,
  saveEmergencyDtrf,
  getEmergencyDtrfList,
  getCommonMasterList,
  saveAppointmentCompleteStatus,
  saveAppointmentNotAttendedStatus,
  getArticleList,
  getArticleHomeList,
  getArticleBySlug,
  saveDoctor,
  sendOtpForForgotPassword,
  resetForgotPassword,
  getDtrfReportList,
  getTestBookList,
  getBookmarkArticles,
  getTestimonial,
  getConsultationView,
  getQuickSupport,
  bookedAppointmentActivityState,
  sendSignUpRequestState,
  cancelAppointment,
  getTestCategories,
  getTokenDetails,
  saveArticleBookmark,
  saveArticleLike,
  getArticleTags,
});
